<template>
  <b-popover
    :ref="`poplist-${targetId}`"
    customClass="ffk-apps-panel"
    :target="targetId"
    triggers="click"
    placement="bottom"
    fallback-placement="flip"
    @show="onShow"
  >
    <fairmat-apps-panel-content v-click-outside="onClickOutside" :apps="apps" @on-click-app="onClickApp" />
  </b-popover>
</template>

<script>
export default {
  name: 'AppsPanel',
  props: {
    targetId: String,
    apps: Array,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    onClickOutside() {
      this.$refs[`poplist-${this.targetId}`].$emit('close')
      this.$emit('on-close')
    },
    onClickApp(app) {
      this.$refs[`poplist-${this.targetId}`].$emit('close')
      this.$emit('on-click-app', app)
    },
    onShow() {
      this.$emit('on-show')
      this.$root.$emit('bv::hide::popover')
    },
  },
}
</script>

<style lang="scss">
.bs-popover-bottom .arrow {
  visibility: hidden;
}

.ffk-apps-panel {
  z-index: 1000 !important;
  border-radius: 5px;
  border-color: var(--gray6) !important;

  .popover-body {
    padding: 0;
  }

  &.popover {
    min-width: 300px !important;
    margin-right: 25px !important;
    margin-top: 25px !important;
  }

  &.bs-popover-left {
    .arrow::after {
      border-left-color: var(--gray6) !important;
    }
  }

  &.bs-popover-right {
    .arrow::after {
      border-right-color: var(--gray6) !important;
    }
  }
}

// override the default styles for external component
.app-item {
  .app-item-list-item {
    .app-name-container,
    .app-description {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
    .app-tenant-container {
      padding-left: 22px !important;
      padding-right: 5px !important;
    }
    .app-item-divider {
      margin-left: 5px !important;
      margin-right: 5px !important;
    }
  }
}
</style>
